import { REFRESH_PERSON, REFRESH_HINTS } from '../../app/constants/exposed-methods';

function exposeMethods(instances) {
	function execute(type, payload) {
		Object.keys(instances).forEach(key => {
			instances[key].update({ type, payload });
		});
	}
	return {
		refreshPerson: data => { execute(REFRESH_PERSON, data); },
		refreshHints: data => { execute(REFRESH_HINTS, data); }
	};
}

export default exposeMethods;
